import { ReactNode } from 'react'
import { SidebarGroup } from './group'
import { SidebarDivider } from './divider'
import { NavigationLink } from './link'
import { SidebarResizeButton } from './resize-button'
import { SidebarProvider } from './sidebar-provider'
import { cn } from '$components'
import { StoredState } from 'src/enums/stored-state'
import { useStoredState } from '$components'

export type SidebarProps = {
  children?: (props: { isOpen: boolean }) => ReactNode
}

export function Sidebar({ children }: SidebarProps) {
  const [isOpen, setOpen] = useStoredState(StoredState.SidebarOpen, true)

  return (
    <SidebarProvider
      value={isOpen}
      setOpen={setOpen}
    >
      <div className={cn(
        'h-full w-64 border-r lg:border-none relative transition-all bg-surface-muted',
        {
          'w-[64px]': !isOpen,
        },
      )}
      >
        {typeof children === 'function' ? children({ isOpen }) : children}
      </div>
    </SidebarProvider>
  )
}

Sidebar.Group = SidebarGroup
Sidebar.Link = NavigationLink
Sidebar.Divider = SidebarDivider
Sidebar.ResizeButton = SidebarResizeButton
